module.exports = __webpack_public_path__ + "img/suscripcion-frecuente.fa8ca5e9.png";